import React, { Component } from 'react'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import findIndex from 'lodash/findIndex'
import cloneDeep from 'lodash/cloneDeep'
import {
    Row,
    Col,
    Modal,
    Form,
    Upload,
    Input,
    InputNumber,
    Button,
    Select,
    Switch,
    Tag,
    Slider,
    Image,
    message
} from 'antd'
import { PlusOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { COLUMNS_INFO } from './../columns'
import { getCategoryInfo, uploadImage } from './../../../services/apiServices'
import { getRandomColor } from './../../../services/appServices'
import RowLayout from './../../../commons/RowLayout/RowLayout'
import ColorSelector from '../../../commons/ColorSelector/ColorSelector'
import CategorySelectorModal from '../../../commons/Modal/CategorySelectorModal/CategorySelectorModal'
import ShortCodeModal from '../../../commons/Modal/Shortcode/ShortCodeModal'
import BannerList from './BannerList'
import CodeEditor from '../../../commons/Editor/CodeEditor'
import LoadingModal from '../../../commons/Modal/Loading'

const { Option, OptGroup } = Select

const WIDTH_MARKS = {
    0: 0,
    8.33: 1,
    16.66: 2,
    24.99: 3,
    33.32: 4,
    41.65: 5,
    49.98: 6,
    58.31: 7,
    66.64: 8,
    74.97: 9,
    83.3: 10,
    91.63: 11,
    100: 12
}

const PADDINGS = [0, 1, 2, 3, 4, 5]

const COVER_ASPECT_RATIO = {
    '1:1': { width: 1, height: 1 },
    '3:2': { width: 3, height: 2 },
    '4:3': { width: 4, height: 3 },
    '16:9': { width: 16, height: 9 },
    '2:3': { width: 2, height: 3 },
    '3:4': { width: 3, height: 4 },
    '9:16': { width: 9, height: 16 }
}

const COVER_ASPECT_RATIO_GROUPS = [
    { name: 'SQUARE', options: ['1:1'] },
    { name: 'LANDSCAPE', options: ['3:2', '4:3', '16:9'] },
    { name: 'PROTRAIT', options: ['2:3', '3:4', '9:16'] }
]

const SORTING_PRODUCT = [
    { key: 'newness', title: 'SORT_NEWNESS' },
    { key: 'popularity', title: 'SORT_POPULARITY' },
    { key: 'rating', title: 'SORT_RATING' },
    { key: 'price_low_to_high', title: 'SORT_PRICE_LOW_HIGHT' },
    { key: 'price_high_to_low', title: 'SORT_PRICE_HIGHT_LOW' },
    { key: 'random', title: 'SORT_RANDOM' }
]

const SORTING_ARTICLE = [
    { key: 'newness', title: 'SORT_NEWNESS' },
    { key: 'title', title: 'SORT_TITLE' },
    { key: 'random', title: 'SORT_RANDOM' }
]

const Container = styled.div`
    .example-image {
        margin-bottom: 24px;
        height: 200px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 100%;
        }
    }
    input,
    option,
    textarea {
        font-weight: 300;
    }
`

class ColumnEditor extends Component {
    state = {
        isRefresh: false,
        isLoading: false,
        isOpenCategorySelectorModal: false,
        isOpenShortcodeModal: false,
        id: '',
        categories: [],
        title: '',
        color: '',
        coverImage: '',
        autoplay: false,
        showTitle: false,
        coverAspectRatio: '1:1',
        rows: 0,
        itemsAll: 0,
        itemsPerRow: {
            lg: 0,
            md: 0,
            xs: 0
        },
        banners: [],
        maxBanners: 1,
        size: 0,
        sortingProduct: '',
        code: '',
        cssClass: '',
        paddingTop: 0,
        paddingBottom: 0,
        existingShortcode: '',
        generatedShortcode: ''
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.isOpen && nextProps.isOpen) {
            let info = nextProps.info

            if (isEmpty(info)) {
                info = COLUMNS_INFO[nextProps.columnType]?.default || {}
            }

            this.setState({ isRefresh: true }, () => {
                this.setState({
                    isRefresh: false,
                    id: info.id || '',
                    categories: info.categories || [],
                    title: info.title,
                    color: info.color || getRandomColor(),
                    coverImage: info.cover_image,
                    autoplay: !!info.autoplay,
                    showTitle: !!info.show_title,
                    rows: info.rows || 1,
                    itemsAll: info.items_all || 1,
                    itemsPerRow: info.items_per_row || {},
                    banners: info.banners || [],
                    maxBanners:
                        COLUMNS_INFO[nextProps.columnType]?.default
                            ?.max_banners || 1,
                    size: (100 / 12) * (info.size || 12),
                    sortingProduct: info.sort_by,
                    code: info.code,
                    cssClass: info.class,
                    paddingTop: info.pt == 0 ? 0 : info.pt || 4,
                    paddingBottom: info.pb == 0 ? 0 : info.pb || 4,
                    coverAspectRatio: this.generateAspectRatioKey(
                        info.cover_aspect_ratio
                    )
                })
            })
        }
    }

    async getCategoryInfo(catId, onSuccess) {
        let { columnType } = this.props
        this.setState({ isLoading: true })
        try {
            let catType =
                COLUMNS_INFO[columnType]?.type == 'PRODUCT'
                    ? 'product_cat'
                    : 'category'
            let catInfo = await getCategoryInfo({
                body: { id: catId, cat_type: catType }
            })
            this.setState({
                isLoading: false
            })
            onSuccess && onSuccess(catInfo)
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async uploadImage(file, onSuccess) {
        this.setState({ isLoading: true })
        try {
            let { image } = await uploadImage({ body: { file } })
            this.setState({ isLoading: false })
            onSuccess && onSuccess(image)
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onSelectCategory(catId) {
        if (findIndex(this.state.categories, ['id', catId]) == -1) {
            this.onToggleCategorySelectorModal(false)
            this.getCategoryInfo(catId, catInfo => {
                let categories = cloneDeep(this.state.categories)
                categories.push({
                    id: catInfo.term_id,
                    name: catInfo.name
                })
                this.setState({ categories })
            })
        } else {
            message.warning(this.props.T('CATEGORY_IS_DUPLICATED'))
        }
    }

    onRemoveCategory(e, index) {
        e.preventDefault()
        let categories = [...this.state.categories]
        categories.splice(index, 1)
        this.setState({ categories })
    }

    onToggleCategorySelectorModal(status) {
        this.setState({
            isOpenCategorySelectorModal: status
        })
    }

    onToggleShortcodeModal(status) {
        this.setState({
            isOpenShortcodeModal: status
        })
    }

    onChangeTitle(title) {
        this.setState({ title })
    }

    onChangeColor(color) {
        this.setState({ color })
    }

    onChangeCoverImage(e) {
        this.uploadImage(e.file.originFileObj, coverImage => {
            this.setState({ coverImage })
        })
    }

    onRemoveCoverImage() {
        this.setState({ coverImage: '' })
    }

    onChangeTotalPosts(numberStr) {
        let number = parseInt(numberStr)
        if (Number.isInteger(number)) {
            this.setState({ itemsAll: number })
        }
    }

    onChangeTotalRows(numberStr) {
        let number = parseInt(numberStr)
        if (Number.isInteger(number)) {
            this.setState({ rows: number })
        }
    }

    onChangeRowPosts(type, numberStr) {
        let number = parseInt(numberStr)
        if (Number.isInteger(number)) {
            let itemsPerRow = cloneDeep(this.state.itemsPerRow)
            itemsPerRow[type] = number
            this.setState({ itemsPerRow })
        }
    }

    onChangeSortingProduct(sorting) {
        this.setState({
            sortingProduct: sorting
        })
    }

    onChangeCssClass(cssClass) {
        this.setState({ cssClass })
    }

    onChangeWidth(width) {
        if (width > 0) {
            this.setState({ size: width })
        }
    }

    onChangeAutoPlay(status) {
        this.setState({ autoplay: status })
    }

    onChangeShowTitle(status) {
        this.setState({ showTitle: status })
    }

    onMoveBanner(index, direction) {
        let banners = cloneDeep(this.state.banners)
        let temp = banners[index]
        if (direction == 'UP') {
            banners[index] = banners[index - 1]
            banners[index - 1] = temp
        } else if (direction == 'DOWN') {
            banners[index] = banners[index + 1]
            banners[index + 1] = temp
        }
        this.setState({ banners })
    }

    onRemoveBanner(index) {
        let banners = cloneDeep(this.state.banners)
        banners.splice(index, 1)
        this.setState({ banners })
    }

    onAddBanner(e) {
        let { T } = this.props
        if (
            this.state.maxBanners == -1 ||
            e.fileList.length <=
                this.state.maxBanners - this.state.banners.length
        ) {
            this.uploadImage(e.file.originFileObj, coverImage => {
                let banners = cloneDeep(this.state.banners)
                banners.push({
                    id: new Date().valueOf(),
                    image: coverImage,
                    title: '',
                    url: ''
                })
                this.setState({ banners })
            })
        } else {
            message.warning(T('EXCEED_LIMIT'))
        }
    }

    onChangeBanner(index, e) {
        this.uploadImage(e.file.originFileObj, coverImage => {
            let banners = cloneDeep(this.state.banners)
            banners[index] = {
                ...banners[index],
                id: new Date().valueOf(),
                image: coverImage
            }
            this.setState({ banners })
        })
    }

    onChangeBannerValue(index, key, value) {
        let banners = cloneDeep(this.state.banners)
        banners[index] = {
            ...banners[index],
            [key]: value
        }
        this.setState({ banners })
    }

    onChangeCode(code) {
        this.setState({ code })
    }

    onChangePadding(position, value) {
        if (position == 'TOP') {
            this.setState({ paddingTop: value })
        } else {
            this.setState({ paddingBottom: value })
        }
    }

    onCoverAspectRatio(aspectRatio) {
        this.setState({ coverAspectRatio: aspectRatio })
    }

    generateAspectRatioKey(ratio = {}) {
        if (!ratio.width || !ratio.height) {
            ratio.width = 4
            ratio.height = 3
        }
        let key = ratio.width + ':' + ratio.height
        return key
    }

    getAspectRatioValue(key) {
        let item = COVER_ASPECT_RATIO[key]
        let ratio = { width: 4, height: 3 }
        if (item) {
            let { width, height } = item
            ratio = { width, height }
        }
        return ratio
    }

    onGetShortcode() {
        let data = this.generateDataToSend()
        let id = data.id
        delete data.id

        let attr = JSON.stringify(data)
        attr = btoa(encodeURIComponent(attr))
        let existingShortcode = id ? `[indymall_column id="${id}"]` : ''
        let generatedShortcode = `[indymall_column_full title="${
            data.title || 'untitled'
        }" data="${attr}"]`
        this.setState({ generatedShortcode, existingShortcode }, () => {
            this.onToggleShortcodeModal(true)
        })
    }

    onSubmit() {
        let { onSubmit } = this.props
        let dataToSend = this.generateDataToSend()
        onSubmit && onSubmit(dataToSend)
    }

    generateDataToSend() {
        const stateKeyMapping = {
            title: 'title',
            color: 'color',
            items_all: 'itemsAll',
            items_per_row: 'itemsPerRow',
            sort_by: 'sortingProduct',
            class: 'cssClass',
            rows: 'rows',
            autoplay: 'autoplay',
            show_title: 'showTitle',
            cover_image: 'coverImage',
            banners: 'banners',
            code: 'code'
        }

        let { columnType } = this.props
        let input = COLUMNS_INFO[columnType]?.default || {}
        let obj = {
            ...input,
            id: this.state.id,
            pt: this.state.paddingTop,
            pb: this.state.paddingBottom
        }

        for (const [key, stateKey] of Object.entries(stateKeyMapping)) {
            if (input.hasOwnProperty(key)) {
                obj = {
                    ...obj,
                    [key]: this.state[stateKey]
                }
            }
        }
        if (input.hasOwnProperty('cat_ids')) {
            obj = {
                ...obj,
                cat_ids: this.state.categories.map(e => e.id),
                categories: this.state.categories
            }
        }
        if (input.hasOwnProperty('size')) {
            obj = {
                ...obj,
                size: Math.round((12 * this.state.size) / 100)
            }
        }
        if (input.hasOwnProperty('cover_aspect_ratio')) {
            obj = {
                ...obj,
                cover_aspect_ratio: this.getAspectRatioValue(
                    this.state.coverAspectRatio
                )
            }
        }

        return obj
    }

    render() {
        let {
            T,
            isOpen,
            columnType = 0,
            info = {},
            onSubmit,
            onClose
        } = this.props

        let input = COLUMNS_INFO[columnType]?.default || {}
        let categoryType = COLUMNS_INFO[columnType]?.type || 'PRODUCT'
        categoryType = categoryType == 'ARTICLE' ? 'POST' : categoryType

        let SORTING =
            categoryType == 'PRODUCT' ? SORTING_PRODUCT : SORTING_ARTICLE

        if (this.state.isRefresh) {
            return null
        }
        return (
            <Modal
                title={`${T('COLUMN')} : ${COLUMNS_INFO[columnType]?.name}`}
                width={720}
                visible={isOpen}
                okText={T('OK')}
                cancelText={T('CANCEL')}
                footer={
                    <Row justify="space-between">
                        <Col>
                            <Button
                                key="shortcode"
                                type="link"
                                style={{ paddingLeft: 0 }}
                                onClick={() => this.onGetShortcode()}>
                                {T('GET_SHORTCODE')}
                            </Button>
                        </Col>
                        <Col>
                            <Button key="back" onClick={() => onClose()}>
                                {T('CANCEL')}
                            </Button>
                            <Button
                                key="submit"
                                type="primary"
                                onClick={this.onSubmit.bind(this)}>
                                {T('OK')}
                            </Button>
                        </Col>
                    </Row>
                }
                onOk={this.onSubmit.bind(this)}
                onCancel={() => onClose()}>
                <Container>
                    <Form labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <div
                            className="example-image"
                            style={{
                                backgroundImage: `url(${window.config.themeUrl}/manager/static/images/layout-column/${COLUMNS_INFO[columnType]?.image})`
                            }}></div>

                        {input.hasOwnProperty('title') && (
                            <RowLayout title={T('TITLE')} contentSpan={14}>
                                <Form.Item>
                                    <Input
                                        placeholder="e.g. ของแต่งบ้าน, เสื้อผ้า, อาหารเสริม"
                                        value={this.state.title}
                                        onChange={e =>
                                            this.onChangeTitle(e.target.value)
                                        }
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('cat_ids') && (
                            <RowLayout
                                title={T('CATEGORIES')}
                                tooltip={T('CATEGORY_INFO_DESC')}
                                contentSpan={14}>
                                <Form.Item>
                                    {this.state.categories.map((cat, index) => (
                                        <Tag
                                            color="blue"
                                            style={{ marginBottom: 5 }}
                                            key={index}
                                            closable
                                            onClose={e =>
                                                this.onRemoveCategory(e, index)
                                            }>
                                            {cat.name}
                                        </Tag>
                                    ))}
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={() =>
                                            this.onToggleCategorySelectorModal(
                                                true
                                            )
                                        }>
                                        {T('SELECT_CATEGORY')}
                                    </Button>
                                </Form.Item>
                            </RowLayout>
                        )}

                        <RowLayout title={T('PADDING_TOP')} contentSpan={18}>
                            <Form.Item>
                                <Select
                                    value={this.state.paddingTop}
                                    style={{ width: 120 }}
                                    onChange={value =>
                                        this.onChangePadding('TOP', value)
                                    }>
                                    {PADDINGS.map(item => (
                                        <Option key={item} value={item}>
                                            {item}{' '}
                                            {item == 4 && ` (${T('DEFAULT')})`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </RowLayout>

                        <RowLayout title={T('PADDING_BOTTOM')} contentSpan={18}>
                            <Form.Item>
                                <Select
                                    value={this.state.paddingBottom}
                                    style={{ width: 120 }}
                                    onChange={value =>
                                        this.onChangePadding('BOTTOM', value)
                                    }>
                                    {PADDINGS.map(item => (
                                        <Option key={item} value={item}>
                                            {item}{' '}
                                            {item == 4 && ` (${T('DEFAULT')})`}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </RowLayout>

                        {input.hasOwnProperty('color') && (
                            <RowLayout title={T('COLOR')} contentSpan={14}>
                                <Form.Item>
                                    <ColorSelector
                                        disableRemoveIcon
                                        color={this.state.color}
                                        onChange={color =>
                                            this.onChangeColor(color)
                                        }
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('cover_aspect_ratio') && (
                            <RowLayout title={T('COVER_ASPECT_RATIO')}>
                                <Form.Item>
                                    <Select
                                        style={{ width: 88 }}
                                        value={this.state.coverAspectRatio}
                                        onChange={this.onCoverAspectRatio.bind(
                                            this
                                        )}>
                                        {COVER_ASPECT_RATIO_GROUPS.map(
                                            group => (
                                                <OptGroup
                                                    key={group.name}
                                                    label={T(group.name)}>
                                                    {group.options.map(key => (
                                                        <Option
                                                            key={key}
                                                            value={key}>
                                                            {
                                                                COVER_ASPECT_RATIO[
                                                                    key
                                                                ].width
                                                            }{' '}
                                                            :{' '}
                                                            {
                                                                COVER_ASPECT_RATIO[
                                                                    key
                                                                ].height
                                                            }
                                                        </Option>
                                                    ))}
                                                </OptGroup>
                                            )
                                        )}
                                    </Select>
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('cover_image') && (
                            <RowLayout
                                title={T('COVER_IMAGE')}
                                contentSpan={14}>
                                <Form.Item>
                                    <div>
                                        <div
                                            style={{
                                                display: 'inline-block',
                                                marginRight: 10
                                            }}>
                                            <Upload
                                                accept="image/gif, image/jpeg, image/png, image/webp"
                                                fileList={[]}
                                                customRequest={() => {}}
                                                onChange={this.onChangeCoverImage.bind(
                                                    this
                                                )}>
                                                <Button
                                                    type="primary"
                                                    icon={<UploadOutlined />}>
                                                    {T('UPLOAD')}
                                                </Button>
                                            </Upload>
                                        </div>
                                        {this.state.coverImage && (
                                            <Button
                                                type="primary"
                                                danger
                                                style={{
                                                    display: 'inline-block',
                                                    marginRight: 5
                                                }}
                                                icon={<DeleteOutlined />}
                                                onClick={() =>
                                                    this.onRemoveCoverImage()
                                                }>
                                                {T('REMOVE')}
                                            </Button>
                                        )}
                                    </div>
                                    {this.state.coverImage && (
                                        <div className="image-wrapper">
                                            <Image
                                                key={this.state.coverImage}
                                                src={this.state.coverImage}
                                            />
                                        </div>
                                    )}
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('autoplay') && (
                            <RowLayout title={T('AUTOPLAY')} contentSpan={14}>
                                <Form.Item>
                                    <Switch
                                        checked={this.state.autoplay}
                                        onChange={this.onChangeAutoPlay.bind(
                                            this
                                        )}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('show_title') && (
                            <RowLayout
                                title={T('SHOW_BANNER_TITLE')}
                                contentSpan={14}>
                                <Form.Item>
                                    <Switch
                                        checked={this.state.showTitle}
                                        onChange={this.onChangeShowTitle.bind(
                                            this
                                        )}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('rows') && (
                            <RowLayout
                                title={T('NUMBER_ROWS_TOTAL')}
                                contentSpan={14}>
                                <Form.Item>
                                    <InputNumber
                                        min={1}
                                        value={this.state.rows}
                                        onChange={this.onChangeTotalRows.bind(
                                            this
                                        )}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('items_all') && (
                            <RowLayout
                                title={T('NUMBER_POSTS_TOTAL')}
                                contentSpan={14}>
                                <Form.Item>
                                    <InputNumber
                                        min={1}
                                        value={this.state.itemsAll}
                                        onChange={this.onChangeTotalPosts.bind(
                                            this
                                        )}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('items_per_row') && (
                            <RowLayout
                                title={T('NUMBER_POSTS_ROW')}
                                contentSpan={14}>
                                <Form.Item>
                                    <InputNumber
                                        min={1}
                                        max={12}
                                        value={this.state.itemsPerRow.lg}
                                        style={{
                                            display: 'inline-block',
                                            marginRight: 10
                                        }}
                                        onChange={value =>
                                            this.onChangeRowPosts('lg', value)
                                        }
                                    />
                                    <span>
                                        <Tag color="magenta">
                                            {T('ON_DESKTOP')}
                                        </Tag>
                                    </span>
                                </Form.Item>
                                <Form.Item>
                                    <InputNumber
                                        min={1}
                                        max={12}
                                        value={this.state.itemsPerRow.md}
                                        style={{
                                            display: 'inline-block',
                                            marginRight: 10
                                        }}
                                        onChange={value =>
                                            this.onChangeRowPosts('md', value)
                                        }
                                    />
                                    <span>
                                        <Tag color="orange">
                                            {T('ON_TABLET')}
                                        </Tag>
                                    </span>
                                </Form.Item>
                                <Form.Item>
                                    <InputNumber
                                        min={1}
                                        max={12}
                                        value={this.state.itemsPerRow.xs}
                                        style={{
                                            display: 'inline-block',
                                            marginRight: 10
                                        }}
                                        onChange={value =>
                                            this.onChangeRowPosts('xs', value)
                                        }
                                    />
                                    <span>
                                        <Tag color="green">
                                            {T('ON_MOBILE')}
                                        </Tag>
                                    </span>
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('sort_by') && (
                            <RowLayout title={T('SORT_BY')} contentSpan={18}>
                                <Form.Item>
                                    <Select
                                        value={this.state.sortingProduct}
                                        style={{ width: 200 }}
                                        onChange={this.onChangeSortingProduct.bind(
                                            this
                                        )}>
                                        {SORTING.map(item => (
                                            <Option
                                                key={item.key}
                                                value={item.key}>
                                                {T(item.title)}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('banners') && (
                            <RowLayout
                                title={T('IMAGES')}
                                contentSpan={14}
                                description={
                                    this.state.maxBanners != -1
                                        ? `${T('MAXIMUM')}: ${
                                              this.state.maxBanners
                                          }`
                                        : ''
                                }>
                                <Form.Item>
                                    <BannerList
                                        T={T}
                                        banners={this.state.banners}
                                        max={this.state.maxBanners}
                                        onAdd={this.onAddBanner.bind(this)}
                                        onChange={this.onChangeBanner.bind(
                                            this
                                        )}
                                        onMove={this.onMoveBanner.bind(this)}
                                        onRemove={this.onRemoveBanner.bind(
                                            this
                                        )}
                                        onChangeValue={this.onChangeBannerValue.bind(
                                            this
                                        )}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('code') && (
                            <RowLayout
                                title={T('CODE')}
                                tooltip={T('CODE_INFO_DESC')}
                                contentSpan={14}>
                                <Form.Item>
                                    <CodeEditor
                                        value={this.state.code}
                                        onChange={this.onChangeCode.bind(this)}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('class') && (
                            <RowLayout
                                title={T('ADDITIONAL_CSS_CLASSES')}
                                contentSpan={14}>
                                <Form.Item>
                                    <Input
                                        placeholder="e.g. class1 class2 class3 ..."
                                        value={this.state.cssClass}
                                        onChange={e =>
                                            this.onChangeCssClass(
                                                e.target.value
                                            )
                                        }
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}

                        {input.hasOwnProperty('size') && (
                            <RowLayout title={T('WIDTH')} contentSpan={14}>
                                <Form.Item>
                                    <Slider
                                        marks={WIDTH_MARKS}
                                        step={null}
                                        tipFormatter={value =>
                                            `${Math.round(value)}%`
                                        }
                                        value={this.state.size}
                                        onChange={this.onChangeWidth.bind(this)}
                                    />
                                </Form.Item>
                            </RowLayout>
                        )}
                    </Form>

                    <CategorySelectorModal
                        T={T}
                        categoryType={categoryType}
                        isOpenModal={this.state.isOpenCategorySelectorModal}
                        onSubmit={this.onSelectCategory.bind(this)}
                        onClose={() =>
                            this.onToggleCategorySelectorModal(false)
                        }
                    />

                    <ShortCodeModal
                        T={T}
                        isOpen={this.state.isOpenShortcodeModal}
                        existingShortcode={this.state.existingShortcode}
                        generatedShortcode={this.state.generatedShortcode}
                        onClose={() => this.onToggleShortcodeModal(false)}
                    />

                    <LoadingModal isOpen={this.state.isLoading} />
                </Container>
            </Modal>
        )
    }
}

export default ColumnEditor
